// extracted by mini-css-extract-plugin
module.exports = {"spotThumbnailBackground":"SpotThumbnailBackground_spotThumbnailBackground__gud_y"};